import React, { useContext, useEffect } from "react";
import LoadingSpinner from "../../components/LoadingSpinner/LoadingSpinner";
import MenuTop from "../../components/MenuTop/MenuTop";
import PdfEditor from "../../components/PdfEditor/PdfEditor";
import { DocumentTypeContext } from "../../context/DocumentContext";
import { useLocation, useNavigate } from "react-router-dom";

const CreateDocument: React.FC = () => {
  const { setIdEditDocument, getDocumentSign, getSignersEdit, setCollaborators, collaborators } =
    useContext(DocumentTypeContext);

  const navigate = useNavigate();
  const location = useLocation();


  useEffect(() => {
    console.log('Colaboradores ao carregar a página:', collaborators);

    const storedState = localStorage.getItem("collaborator-storage");
    if (storedState) {
      const parsedState = JSON.parse(storedState);
      if (parsedState?.state?.collaborators?.length > 0) {
        console.log('Carregando colaboradores do localStorage:', parsedState.state.collaborators);
        setCollaborators(parsedState.state.collaborators);
      }
    }

    const url = window.location.href;
    const urlObj = new URL(url);
    const documentId = urlObj.searchParams.get("documentId");

    const getDocument = async () => {
      if (documentId) {
        setIdEditDocument(documentId);
        await getDocumentSign(documentId);
        await getSignersEdit(documentId);
      }
    };

    getDocument();
  }, [setCollaborators, setIdEditDocument, getDocumentSign, getSignersEdit]);

  return (
    <>
      <LoadingSpinner />
      <MenuTop />
      <div
        className="mt-2 ml-2 mr-2 pt-4 pb-4 pl-4 d-flex"
        style={{
          height: "100%",
          backgroundColor: "#fff",
          flexDirection: "row",
          gap: "20px",
        }}
      >
        <div style={{ flex: 2 }}>
          <div className="d-flex mb-4" style={{ gap: "20px" }}>
            <div className="d-flex" style={{ flexDirection: "column" }}>
              <span className="title-init-document">ASSINAR DOCUMENTO</span>
              <span className="title-init-document-2">
                ESCOLHA ONDE DESEJA ASSINAR E RUBRICAR
              </span>
            </div>
          </div>
          <PdfEditor />
        </div>
      </div>
    </>
  );
};

export default CreateDocument;
